"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _keyOrIndexToIndex = _interopRequireDefault(require("./keyOrIndexToIndex"));

var _wrapNumber = _interopRequireDefault(require("./wrapNumber"));

var _prepareChildKeys = _interopRequireDefault(require("./prepareChildKeys"));

var _updateChildKeys = _interopRequireDefault(require("./updateChildKeys"));

var _insert = _interopRequireDefault(require("unmutable/lib/insert"));

var _size = _interopRequireDefault(require("unmutable/lib/size"));

var _default = function _default(after) {
  return function (key, newValue) {
    return function (parcelData) {
      var parcelDataWithChildKeys = (0, _prepareChildKeys.default)()(parcelData);
      var index = (0, _keyOrIndexToIndex.default)(key)(parcelDataWithChildKeys);

      if (typeof index !== "number") {
        return parcelDataWithChildKeys;
      }

      index = (0, _wrapNumber.default)(index, (0, _size.default)()(parcelData.value)) + (after ? 1 : 0);
      var value = parcelDataWithChildKeys.value,
          child = parcelDataWithChildKeys.child;
      return (0, _updateChildKeys.default)()((0, _objectSpread2.default)({}, parcelDataWithChildKeys, {
        value: (0, _insert.default)(index, newValue)(value),
        child: (0, _insert.default)(index, {})(child)
      }));
    };
  };
};

exports.default = _default;